import Papa from 'papaparse';

export default function checkCSVRows({ file, rules }) {
  return new Promise((resolve, reject) => {
    let indexedErrors = {};
    let errorCounts = {};
    let indexedWarnings = {};
    let warningCounts = {};
    let seenValues = {};
    let rowIndex = 1;

    const addTo = (index, counts, cell) => {
      if (!index[rowIndex]) index[rowIndex] = [];
      index[rowIndex].push(cell);

      // Increment the count for the column
      counts[cell.column] = (counts[cell.column] || 0) + 1;
    };

    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      step: (result) => {
        const row = result.data;

        // Validate row
        Object.entries(row).forEach(([header, value]) => {
          const rule = rules[header];
          if (!rule) return;

          if (!rule.validator || !rule.validator(value, row)) {
            addTo(indexedErrors, errorCounts, {
              row: rowIndex,
              column: header,
              value,
              errorType: 'Invalid value',
              errorMessage: value ? `Invalid value for ${header} "${value}"` : `Value not provided`,
              ruleDescription: rule.description,
            });
            return;
          }

          if (rule.uniqueInFile) {
            const key = String(value).trim();
            if (!seenValues[header]) seenValues[header] = new Set();

            if (seenValues[header].has(key)) {
              addTo(indexedErrors, errorCounts, {
                row: rowIndex,
                column: header,
                value,
                errorType: 'Duplicate value',
                errorMessage: `Duplicate value for ${header} "${value}"`,
                ruleDescription: rule.description,
              });
              return;
            }

            seenValues[header].add(key);
          }

          const warningMessage = rule.warning ? rule.warning(value, row) : null;
          if (warningMessage) {
            addTo(indexedWarnings, warningCounts, {
              row: rowIndex,
              column: header,
              value,
              errorType: 'Conflicting value',
              errorMessage: warningMessage,
              ruleDescription: rule.description,
            });
          }
        });

        rowIndex++;
      },
      complete: () => {
        const passesCheck = Object.keys(indexedErrors).length === 0;

        resolve({
          type: passesCheck ? 'success' : 'error',
          summary: { passesCheck },
          messages: passesCheck ? ['All rows have valid data.'] : indexedErrors,
          errorCounts, // Include the error counts in the response
          warnings: indexedWarnings,
          warningCounts,
        });
      },
      error: (error) => {
        reject({
          type: 'error',
          summary: { passesCheck: false },
          messages: [`Error parsing CSV file: ${error.message}`],
        });
      },
    });
  });
}
